import {Injectable} from "@angular/core";
import {ApiService} from "@amlCore/services";
import {Observable} from "rxjs";
import {FStateItem, MvkDecisionDetails, PaycardSubject, RiskfactorClasses, RiskfactorInfo} from "../model";
import {CheckDictEnum} from "@amlCore/enums";
import {AlertPanelComponent, AlertPanelService, AlertService} from "@amlCore/components";
import {RiskfactorEnum} from "../enums";
import {FilterParams} from "@amlCore/models";
import {IDataResponse} from "@amlCore/interfaces";
import {TerroristSubject} from "../model/terrorist";
import {ConfirmComponent} from "@amlCore/modals";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {finalize} from "rxjs/operators";


@Injectable()
export class RegistriesService {

  constructor(private api: ApiService,
              private alertSrv: AlertService,
              private alertPanelSrv: AlertPanelService,
              private modalService: NgbModal,
              private readonly router: Router) {
  }

  filterValue: object = this.getDefaultFilterSPK();

  getDefaultFilterSPK() {
    return {
      param: {
        type: null
      },
      lists: {
        checkListOfTerrorists: null,
        checkMvk: null,
        checkBounceRegister: null
      },
      scroll: {
        id: null,
      }
    }
  }

  get savedFilterSPK(): any {
    return this.filterValue;
  }

  set savedFilterSPK(obj: any) {
    this.filterValue[obj.groupName][obj.key] = obj.value || null;
  }

  downloadSPK(params: any) {
    return this.api.byte('/api/v1/export/spk/zip', params);
  }

  exportSPKExcel(params: any) {
    return this.api.byte('/api/v1/export/spk/xlsx', params);
  }

  resetFilterSPK() {
    this.filterValue = this.getDefaultFilterSPK();
  }

  getFromuList(params: any): Observable<any> {
    return this.api.get('/api/v1/qref/fromu', params, 'id');
  }

  getFromuFullInfoList(params: any): Observable<any> {
    return this.api.get('/api/v1/qref/fromu/info/full', params, 'id');
  }

  getNelegalList(params: any): Observable<any> {
    return this.api.get("/api/v1/qref/nelegal/subjects", params, 'id');
  }

  getConsolidatedList(params: any): Observable<any> {
    return this.api.get('/api/v1/cls/extter/consolidated', params, 'id');
  }

  getConsolidatedFullInfoList(params: any): Observable<any> {
    return this.api.get('/api/v1/cls/extter/consolidated/info/full', params, 'id');
  }

  getConsolidatedById(id: string): Observable<any> {
    return this.api.get(`/api/v1/cls/extter/consolidated/view/${id}`);
  }

  getUnwantedInfoList(params: any): Observable<any> {
    return this.api.get('/api/v1/qref/unwanted/info', params, 'id');
  }

  getUnwantedList(params: any): Observable<any> {
    return this.api.get('/api/v1/qref/unwanted/subjects', params, 'id');
  }

  getInagentInfoList(params: any): Observable<any> {
    return this.api.get('/api/v1/qref/inagent/info', params, 'id');
  }

  getInagentList(params: any): Observable<any> {
    return this.api.get('/api/v1/qref/inagent/subjects', params, 'id');
  }

  getInagentById(id: string): Observable<any> {
    return this.api.get(`/api/v1/qref/inagent/${id}`);
  }

  getMvkList(params: any): Observable<any> {
    return this.api.get('/api/v1/cls/extter/mvk', params, 'id');
  }

  getBounceRegisterList(params: any): Observable<any> {
    return this.api.get('/api/v1/cls/refusal/', params, 'id');
  }

  getBounceFullInfoList(params: any): Observable<any> {
    return this.api.get('/api/v1/cls/refusal/accepted/full/', params, 'id');
  }

  getBounceFullInfoChecksList(params?: any): Observable<any> {
    return this.api.get('/api/v1/otkaz/accepted/checks');
  }

  getBounceRegisterById(id: string): Observable<any> {
    return this.api.get(`/api/v1/cls/refusal/${id}`);
  }

  getFromuById(id: string): Observable<any> {
    return this.api.get(`/api/v1/qref/fromu/view/${id}`);
  }

  getMvkById(id: string, subjectId: string): Observable<MvkDecisionDetails> {
    return this.api.get(`/api/v1/cls/extter/mvk/resh/${id}/${subjectId}`);
  }


  /**
   * Получить список террористов
   */
  getTerroristList(params: any): Observable<any> {
      return this.api.get("/api/v1/cls/extter/terror/search", params, 'id');
  }

  /**
   * получить список по платежной карте
   */
  getPaycardSubjectList(params: FilterParams): Observable<IDataResponse<PaycardSubject>> {
    return this.api.get(`/api/v1/cls/ctfb/list`, params);
  }



  /**
   * получение списка импортированных файлов со списками иностранных государств
   */
  getFStates(params: FilterParams): Observable<IDataResponse<FStateItem>> {
    return this.api.get(`/api/v1/cls/ctfb5016/list`, params);
  }

  /**
   * Получение информации по террористу
   */
  getTerroristById(id: string): Observable<TerroristSubject> {
    return this.api.get(`/api/v1/cls/extter/terror/view/${id}`);
  }

  /**
   * Закачать файл
   */
  uploadFile(event, patch): Observable<any> {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file);
      return this.api.sendFormData(patch, formData);
    }
  }

  removeFile(url: string, params?: any) {
    return params ?
    this.api.get(url, params) :
    this.api.get(url);
  }

  //метод для удаления реестра refusal. Возможно будут изменение в других документах,
  //поэтому отдельный метод на будущее, чтобы потом можно было заменить старый removeFile
  deleteFile(url: string, params?: any) {
    return this.api.delete(url);
  }

  deleteRiskfactor(id) {
    return this.api.delete(`/api/v1/riskfactor/info/${id}`);
  }


  deleteClasses(id) {
    return this.api.delete(`/api/v1/riskfactor/class/${id}`);
  }

  /**
   * Получить список массовых лидеров
   */
  getMassLeadSubjectList(params: any, id): Observable<any> {
    if (id) {
      return this.api.get("/api/v1/qref/mslead/entry/" + id, params);
    } else {
      return this.api.get("/api/v1/qref/mslead/entry", params);
    }
  }

  /**
   * Получить список массовых лидеров
   */
  getMassFoundSubjectList(params: any, id): Observable<any> {
    if (id) {
      return this.api.get("/api/v1/qref/msfound/entry/" + id, params);
    } else {
      return this.api.get("/api/v1/qref/msfound/entry", params);
    }
  }

  /**
   * Получить внутренний перечень организации
   */
  getInternalOrgList(params: any, id): Observable<any> {
    if (id) {
      return this.api.get("/api/v1/qref/internal/" + id, params);
    } else {
      return this.api.get("/api/v1/qref/internal", params);
    }
  }

  /**
   * Получить список адресов массовой регистрации ЮЛ
   */
  getMassAdrSubjectList(params: any, id): Observable<any> {
    if (id) {
      return this.api.get("/api/v1/qref/msadr/entry/" + id, params);
    } else {
      return this.api.get("/api/v1/qref/msadr/entry", params);
    }
  }

  /**
   * Получить список должников ФТС
   */
  getFtsSubjectList(params: any, id): Observable<any> {
    if (id) {
      return this.api.get("/api/v1/qref/fts/entry/" + id, params);
    } else {
      return this.api.get("/api/v1/qref/fts/entry", params);
    }
  }

  /**
   * Получить список групп риска (794-П)
   */
  getRiskGroupSubjectList(params: any): Observable<any> {
    return this.api.get('/api/v1/cls/kyc/', params, 'id');
  }
  /**
   * Получить список недействительных паспортов
   */
  getPassportSubjectList(params: any): Observable<boolean> {
    return this.api.get("/api/v1/qref/passport/check", params);
  }

  /**
   * получить список факторов риска
   */
  getRiskfactorEntries(params: any): Observable<any> {
    return this.api.get("/api/v1/riskfactor/entries", params, 'id');
  }

  /**
   * получить фактор риска
   */
  getRiskfactorInfo(id): Observable<any> {
    return this.api.get("/api/v1/riskfactor/info/" + id);
  }

  /**
   * получение классов проверок
   */
  getRiskfactorClasses(params?: any, type: RiskfactorEnum[] = null) {
    if (type && Array.isArray(type) && type.length) {
      params.filter = Object.assign(params.filter || {}, {typeList: type.join(',')})
    }
    return this.api.post("/api/v1/riskfactor/classes", params, 'id');
  }

  /**
   * получение справочника Повышающий коэффициент
   */
   getscoreDegreeWithIncreases() {
    return this.api.get("/api/v1/qref/scoreDegreeWithIncrease/entry");
  }

  /**
   * получение класса проверки
   */
  getRiskfactorClassById(id: string) {
    return this.api.get(`/api/v1/riskfactor/class/${id}`);
  }

  /**
   * Сохранить/обновить фактор риска
   */
  saveRiskfactorInfo(id: string, item: RiskfactorInfo) {
    let url = '/api/v1/riskfactor/info';
    // Есть id - обновление
    if (id) {
      url += '/' + id;
    }
    return this.api.post(url, item);
  }

  /**
   * Сохранить/обновить класс фактора риска
   */
  saveRiskfactorClass(id: string, item: RiskfactorClasses) {
    let url = '/api/v1/riskfactor/class/';
    // Есть id - обновление
    if (id) {
      url += id;
    }
    return this.api.post(url, item);
  }

  /**
   * Проверка перечний
   * @param id - id перечня
   * @param type - тип перечня
   */
  checkRiskFactor(id: string, type: CheckDictEnum) {
    if([CheckDictEnum.QREF281FZ, CheckDictEnum.NELEGAL].includes(type)) {
      return this.api.get(`/api/v1/check/riskfactor/${type}`);
    }
    return this.api.get(`/api/v1/check/riskfactor/${type}/${id}`);
  }

  /**
   * Проверка перечней по факторам риска
   * @param item - проверяемый элемент
   * @param dict - тип перечня
   * @param loadCheckList - объект признака загрузки
   * @param alertObj - объект для сообщения
   */
  doCheckRiskFactor(item: any, dict: CheckDictEnum, loadCheckList: any, alertObj: AlertPanelComponent, callback?: (item: any, result: any) => void) {
    this.alertSrv.clear();
    loadCheckList[item.id] = true;
    return this.checkRiskFactor(item.id, dict)
      .pipe(finalize(() => loadCheckList[item.id] = false))
      .subscribe(data => {
      if (data) {
        item.checkDate = data.checkDate;
        item.checkResult = data.checkResult;
        let msg;
        if(item.checkResult > 0) {
          if(dict == CheckDictEnum.NELEGAL){
            const modal = this.modalService.open(ConfirmComponent);
            modal.componentInstance.text = `Проверка завершена, найдено ${item.checkResult} совпадений, перейти в раздел \"Результаты проверки\"?`;
            modal.result.then(
              () => {
                this.router.navigateByUrl('/cabinet/dossier/check')
              },
              cancel => {return; });
          } else {
            msg = `Проверка завершена, найдено совпадений: ${item.checkResult}`;
          }
        } else {
          msg = item.existsPrev ? 'Новых соответствий по перечню не обнаружено' : 'Соответствий по перечню не обнаружено';
        }
        if(msg)
          alertObj.open(this.alertPanelSrv.getSuccessMsg(msg));

        callback?.(item, data);
      }
    });
  }


}
